import { HTMLAttributes } from 'react';
import { css, keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { KeyOf } from '~/types';
import { ContentKeys } from '~/styles/themes';

export const SpinnerSize = {
  xLarge: 50,
  large: 24,
  medium: 20,
  small: 16,
  xSmall: 14,
} as const;

export const SpinnerThickness = {
  bold: 4,
  normal: 3,
  light: 2,
} as const;

export interface SpinnerProps extends HTMLAttributes<HTMLDivElement> {
  color?: ContentKeys;
  size?: KeyOf<typeof SpinnerSize>;
  thickness?: KeyOf<typeof SpinnerThickness>;
}

export interface StyleSpinnerProps {
  color: SpinnerProps['color'];
  size: SpinnerProps['size'];
  thickness: SpinnerProps['thickness'];
}

export default function Spinner({
  color,
  size,
  thickness,
  ...props
}: SpinnerProps) {
  return (
    <SpinnerIcon color={color} size={size} thickness={thickness} {...props} />
  );
}

export const SpinnerIcon = styled.div<StyleSpinnerProps>`
  ${({ theme, color, size, thickness }) => css`
    display: inline-block;
    width: ${size ? `${SpinnerSize[size]}px` : '20px'};
    height: ${size ? `${SpinnerSize[size]}px` : '20px'};
    animation: ${spinnerKeyframes} 1s infinite linear;
    border-width: ${thickness ? `${SpinnerThickness[thickness]}px` : '2px'};
    border-style: solid;
    border-radius: 50%;
    border-color: ${color ? `${theme.content[color]}` : 'inherit'};
    border-top-color: transparent;
  `}
`;

const spinnerKeyframes = keyframes`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`;
